import { TFunction } from 'i18next';

export enum EPeerReviewTabsKeys {
  ReviewNotes = 'review-notes',
}

export const getTabs = (t: TFunction) => [
  {
    key: EPeerReviewTabsKeys.ReviewNotes,
    label: t('peerReview.tabs.reviewNotes'),
  },
];
